import * as React from 'react'

import { cn } from './utils'

import { fieldClass } from './field-class'

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          fieldClass,
          'flex h-8 py-1 file:border-0 file:bg-transparent file:text-sm file:font-semibold file:text-ink',
          type === 'file' && 'h-auto',
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = 'Input'

export { Input }
